import ReportsBase from "./reportsBase";

export default ReportsBase;
